import { HTMLProps, useEffect, useRef } from 'react';
import { px } from '../../utils/styles/px';
import { useCloseKeyboardOnScroll } from './hooks/useCloseKeyboardOnScroll';
import { makeTextControl } from './makeTextControl';

const AutoSize = (props: HTMLProps<HTMLTextAreaElement>) => {
    const { value = '', ...other } = props;
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useEffect(() => {
        if (textareaRef && textareaRef.current) {
            textareaRef.current.style.height = '0px';
            textareaRef.current.style.height = px(textareaRef.current.scrollHeight);
        }
    }, [value]);

    useCloseKeyboardOnScroll(textareaRef);

    return <textarea {...other} value={value} ref={textareaRef} />;
};

export const TextArea = makeTextControl<HTMLTextAreaElement>(AutoSize);
